import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { faqData } from '../../data/mock';
import Reveal from './Reveal';

const FAQSection = () => {
  const mid = Math.ceil(faqData.length / 2);
  const columns = [faqData.slice(0, mid), faqData.slice(mid)];

  return (
    <section id="faq" className="py-20 md:py-28 bg-[#fafafa]" data-testid="faq-section">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        {/* Header */}
        <Reveal className="text-center mb-12 md:mb-16">
          <p className="text-[#0C6951] text-sm font-bold tracking-[0.15em] uppercase mb-4">
            Questions?
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-[#004534] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-xl mx-auto">
            Everything you need to know before you lease
          </p>
        </Reveal>

        {/* Two-column accordion */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto items-start">
          {columns.map((col, colIndex) => (
            <Reveal key={colIndex} delay={colIndex * 100} className="w-full">
              <Accordion type="single" collapsible className="space-y-4">
                {col.map((faq, index) => {
                  const value = `col-${colIndex}-item-${index}`;
                  return (
                    <AccordionItem
                      key={value}
                      value={value}
                      className="bg-white rounded-2xl border border-gray-100 shadow-sm px-5 overflow-hidden data-[state=open]:shadow-md data-[state=open]:border-[#c4e538]/50 transition-all duration-300"
                      data-testid={`faq-${colIndex}-${index}`}
                    >
                      <AccordionTrigger className="text-left py-5 text-[#004534] font-bold text-base hover:no-underline hover:text-[#0C6951] [&[data-state=open]]:text-[#0C6951]">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-gray-600 pb-5 text-sm leading-relaxed">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            </Reveal>
          ))}
        </div>

        {/* Still have questions nudge */}
        <Reveal className="text-center mt-12" delay={120}>
          <p className="text-gray-500 text-sm">
            Still have questions?{' '}
            <a href="tel:+916292050222" className="text-[#0C6951] font-semibold underline underline-offset-2 hover:text-[#004534]">
              Call us at +91 6292050222
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQSection;
